import React, { useCallback } from 'react';
import { Platform, View } from 'react-native';
import type { SvgProps } from 'react-native-svg';
import { Text } from '~/components';

export interface ResumeItemProps {
  icon: React.FC<SvgProps>;
  description: string | React.ReactElement;
}

const ResumeItem: React.FC<ResumeItemProps> = (props) => {
  const RenderIcon = useCallback(() => {
    const { icon: Icon } = props;

    return <Icon />;
  }, [props]);

  return (
    <View
      className={`flex-row items-center py-3 shadow bg-light-100 mb-2 p-4 rounded-lg ${
        Platform.OS === 'android' ? 'shadow-black/40' : ''
      }`}
    >
      <RenderIcon />

      <Text className="text-xs text-gray-600 ml-4 flex-1">
        {props.description}
      </Text>
    </View>
  );
};

export default ResumeItem;
